<template>
  <div class="whoarewe-div">
    <div class="upper-menu" v-if="this.isShowUpMenu">
      <img @click="goToStart"
           v-if="window.location.href.includes('projects') || window.location.href.includes('contactus')"
           class="menu-icon-left" src="/static/img/global/hippo_logo_purple.svg" alt="Menu">
      <img @click="goToStart" v-else class="menu-icon-left" src="/static/img/global/hippo_logo_white.svg"
           alt="Menu">

      <img @click="goToMenu" class="menu-icon" src="/static/img/menu.svg" alt="Menu"
           v-if="!window.location.href.includes('site-menu') && !window.location.href.includes('projects')">
      <img @click="goToMenu" class="menu-icon" src="/static/img/menu-copy-2.svg" alt="Menu"
           v-if="window.location.href.includes('projects') || window.location.href.includes('contactus')">
      <img v-if="window.location.href.includes('cover') && !this.isMobile" class="menu-project-right"
           @click="seeOurProjects" src="/static/img/menu-project-2.png" alt="Projects">
    </div>
    <MenuSide></MenuSide>

    <div v-if="!this.isMobile" class="banner">

      <img class="bg" src="../../static/img/WhoAreWe/shelly.jpg" srcset="/static/img/WhoAreWe/shelly.jpg" alt="Hippotec"
           v-bind:style="{'height':this.mobileSite.bannerHeight}">

      <div class="container logo">
        <div class="row">
          <div class="col-xl-12 col-md-12 col-sm-12 ">
            <div class="title-image"
                 v-bind:style="{'font-size':this.mobileSite.titleFontSize, 'font-weight': this.mobileSite.titleWeight}">
              NICE TO
            </div>
            <div class="title-image"
                 v-bind:style="{'font-size':this.mobileSite.titleFontSize, 'font-weight': this.mobileSite.titleWeight}">
              MEET YOU!
            </div>
            <img class="curved-line" src="../../static/img/global/pink-line.svg" alt="">
          </div>
          <div class="col-xl-12 col-md-12 col-sm-12 row-col">
            <div class="title-image-small">A bit about our unique team ( This is Shelly in the picture )</div>
            <div class="title-image-small">We know how designers and developers ( and dogs ) collaboration is<br/>
              essential for any project.
            </div>
          </div>
        </div>
        <button @click="letsTalk" class="submit-button" type="submit">LET'S TALK</button>
      </div>
      <div class="overlay"></div>
    </div>
    <div v-else class="mobile-banner">

      <img class="bg" src="../../static/img/WhoAreWe/shelly.jpg" srcset="/static/img/WhoAreWe/shelly.jpg" alt="Hippotec"
           v-bind:style="{'height':this.mobileSite.bannerHeight}">

      <div class="container uppertext">
        <div class="row">
          <div class="col-xl-12 col-md-12 col-sm-12 ">
            <div class="title-image"
                 v-bind:style="{'font-size':this.mobileSite.titleFontSize, 'font-weight': this.mobileSite.titleWeight}">
              NICE TO
            </div>
            <div class="title-image"
                 v-bind:style="{'font-size':this.mobileSite.titleFontSize, 'font-weight': this.mobileSite.titleWeight}">
              MEET YOU!
            </div>
            <img class="curved-line" src="../../static/img/global/pink-line.svg">
          </div>
          <div class="col-xl-12 col-md-12 col-sm-12 row-col">
            <div class="mobile-title-image-small">A bit about our unique team (This is Shelly in the picture). We know
              how designers and developers (and dogs) collaboration is essential for any project.
            </div>
          </div>
        </div>
        <button @click="seeOurProjects" class="submit-button" type="submit">LET'S TALK</button>
      </div>
      <div class="overlay"></div>
    </div>

    <div class="whoarewe-description-div">
      <h1 class="whoarewe-description-title1">ABOUT US</h1>

      <div v-bind:class="this.titleTextClass">
        <div class="whoarewe-descriptiontext2">We are, dedicated, passionate hard working people who really care.
          We are breathing design & develop every day.
        </div>
        <span> <div class="whoarewe-descriptiontext1">Specialize in UI/UX design, iOS, Android & Web environments with a super skilled development team
          who will be more than happy to bring to life your baby product. <br>Together, we identify weak points of your product and create innovative,
          friendly and smart solutions.We love what we do, we take every tasks with a 100% attention so there are no mistakes,
          while making sure to top quality and on time delivery. <span class="whoarewe-descriptiontext3">We envision, we design, we code and we launch!</span>
        </div>

        </span>
      </div>
      <img class="line" src="../../static/img/global/purple-line.svg">

    </div>

    <div class="whoarewe-workers-div">
      <div class="whoarewe-worker-div" v-for="worker in workers">
        <img class="whoarewe-worker-image" :src="worker.image">
        <h1 class="whoarewe-worker-name">{{ worker.name }}</h1>
        <p :style=" worker.role == 'Send your CV' ? 'cursor: pointer; text-decoration: underline' : 'cursor: auto;'"
           @click="sendCV" class="whoarewe-worker-role">{{ worker.role }}</p>
      </div>
    </div>
    <ContactUs></ContactUs>

  </div>
</template>
<script>
  //import MenuSide from "../components/MenuSide";
  import bg from "../../static/img/WhoAreWe/shelly.jpg"
  import bgmobile from "../../static/img/WhoAreWe/shellymobile.png"
  import logonew from "../../static/img/WhoAreWe/logo.png"
  import logomobile from "../../static/img/WhoAreWe/logomobile.png"
  import seeourprojects from "../../static/img/WhoAreWe/see-our-projects.svg"
  import seeourprojectsmobile from "../../static/img/WhoAreWe/hippoIconmobile.png"
  //import ContactUs from "../components/ContactUs"
  import Vue from 'vue'

  import MenuSide from '@bit/hippotec.website2019.menu-side';
  import ContactUs from '@bit/hippotec.website2019.contact-us';

  export default {
    name: 'WhoAreWe',
    data() {
      return {
        isShowUpMenu: false,
        upperMenuTopLast: 0,
        workers: window.workersData,
        backgroundImage: bg,
        logo: logonew,
        seeOurProjects2: seeourprojects,
        window,
        mobileSite: {
          titleFontSize: '60px',
          titleWeight: '500',
          bannerHeight: '100%',
          titleTextClass: '',
          /*titleTextClassWeb: {
            display: 'flex',
            flexDirection: 'row',
            height: '243px'
          },
          titleTextClassMobile: {
            display: 'flex',
            flexDirection: 'column',
          }*/
        }
      }
    },
    components: {
      ContactUs,
      MenuSide: MenuSide
    },
    methods: {
      seeOurProjects: function () {
        this.$router.push('projects')
      },
      sendCV: function (event) {
        if (event.target.textContent == 'Send your CV') {
          this.$router.push('career')
        }
      },
      seeOurProjectsBtn: function () {
        this.$router.push('projects')
      },
      letsTalk: function () {
        this.$router.push('contactus')
      },
      prepareMobile(isMobile) {
        this.isMobile = isMobile;
        if (isMobile) {
          this.backgroundImage = bgmobile;
          this.logo = logomobile;
          this.seeOurProjects2 = seeourprojectsmobile;
          this.mobileSite.titleFontSize = '40px';
          this.mobileSite.titleWeight = '500';
          this.mobileSite.bannerHeight = '520px';
          this.titleTextClass = 'titleTextClassMobile';
        } else {
          this.backgroundImage = bg;
          this.logo = logonew;
          this.seeOurProjects2 = seeourprojects;
          this.titleTextClass = 'titleTextClassWeb';
        }
      },
      checkScroll() {
        var $win = $(window);
        //console.log($win.scrollTop())
        if ($win.scrollTop() > 200) {
          if (this.upperMenuTopLast > $win.scrollTop()) {
            this.isShowUpMenu = true;
          }else{
            this.isShowUpMenu = false;
          }
          this.upperMenuTopLast = $win.scrollTop()
        }else{
          this.isShowUpMenu = false;
        }
        //console.log(this.isShowUpMenu);
      },
      goToMenu: function () {
        this.$router.push('/site-menu');
      },
      goToStart: function () {
        this.$router.push('/what-we-do');
      },
    },
    created() {
      this.prepareMobile(localStorage.isMobile == 'true');
    },
    mounted() {
      var $win = $(window);
      $win.scroll(this.checkScroll);
    }
  }

</script>
<style lang="scss" scoped>
  @import "../assets/scss/whoAreWe.scss";

  .upper-menu {
    transition: float 4s ease-in-out;
    position: fixed;
    opacity: 0.7;
    width: 100%;
    height: 110px;
    background-color: #000000;
    top: 0;
    left: 0;
    z-index: 2000;
  }

  .all {
    position: absolute;
  }

  .titleTextClassWeb {
    display: flex;
    flex-direction: column;
    //height: 243px;
  }

  .titleTextClassMobile {
    display: flex;
    flex-direction: column;
  }

  .mobile-title-image-small {
    font-family: Rubik, sans-serif;
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.39;
    letter-spacing: normal;
    margin-top: 20px;
    color: var(--white);
  }

  .uppertext {
    position: absolute;
    top: 100px;
    left: 35px;
    width: 90%;
    max-width: 100%;
    //text-align: center;
    // transform: translate(-50%, -50%);
    z-index: 1;
  }

  .title-image {
    text-align: left;
    font-family: Rubik, sans-serif;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.1;
    letter-spacing: normal;
    color: #ff9efd;
  }

  .banner {
    width: 100%;
    height: 700px;
    overflow: hidden;
    position: relative;

    .bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.8;
      object-position: center;
    }

    .logo {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 60%;
      max-width: 100%;
      text-align: center;
      transform: translate(-50%, -50%);
      z-index: 1;

      img {
        zoom: 1.2;
        width: 174px;
        height: 98px;
        object-fit: cover;
        object-position: center;
        margin-bottom: 20px;
      }

      p {
        width: 969px;
        max-width: 100%;
        margin: auto;
        color: #fff;
        font-size: 33px;
        font-weight: 300;
        text-align: center;
      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
    }
  }

  .mobile-banner {
    width: 100%;
    height: 520px;
    overflow: hidden;
    position: relative;

    .bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.8;
      object-position: center;
    }

    .logo {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 60%;
      max-width: 100%;
      text-align: center;
      transform: translate(-50%, -50%);
      z-index: 1;

      img {
        zoom: 1.2;
        width: 174px;
        height: 98px;
        object-fit: cover;
        object-position: center;
        margin-bottom: 20px;
      }

      p {
        width: 969px;
        max-width: 100%;
        margin: auto;
        color: #fff;
        font-size: 33px;
        font-weight: 300;
        text-align: center;
      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/WhoAreWe.vue